export const INIT_SPACE_CREATION = 'INIT_SPACE_CREATION';

export const SPACE_CREATION_ERROR = 'SPACE_CREATION_ERROR';
export const SPACE_CREATION_SUCCESS = 'SPACE_CREATION_SUCCESS';



// WEBPACK FOOTER //
// ./src/create-space/action-types.js